import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TreatmentPlanMetaService } from 'src/app/service/treatment-plan-meta.service';

export interface PdtCommentaireDTO {
  id?: number;
  type: number;
  idPDT: number;
  commentaire: string;
  writtenBy: string;
  createdAt?: Date;
}

export interface CommentsChangedEvent {
  idPDT: number;
  type: number;
  comments: PdtCommentaireDTO[];
}

@Component({
  selector: 'app-pdt-comments',
  templateUrl: './pdt-comments.component.html',
  styleUrls: ['./pdt-comments.component.scss'],
})

export class PdtCommentsComponent implements OnInit {
@Input() idPDT!: number;
@Input() type: number = 3;
@Input() visible: boolean = false;
@Output() visibleChange = new EventEmitter<boolean>();
@Input() canWrite: boolean = true;
@Input() comments: PdtCommentaireDTO[] = [];
@Output()commentsChange = new EventEmitter<any>();
@Output() close = new EventEmitter<void>();

newComment: PdtCommentaireDTO = {
  type: 3,
  idPDT: this.idPDT,
  commentaire: '',
  writtenBy: ''
};

currentUser = ''; // remplace par ton user réel
editingIndex: number | null = null;
isEditing: boolean = false;
title: string = "Commentaires";
addComment() {
  if (!this.newComment.commentaire) return;

  const payload: PdtCommentaireDTO = {
    id: this.isEditing ? this.comments[this.editingIndex!].id : null,
    type: this.type,
    idPDT: this.idPDT,
    commentaire: this.newComment.commentaire,
    writtenBy: this.currentUser,
    createdAt: new Date()
  };
console.log('payload',payload);

  this.treatmentMetaService.addPlanDeTraitementComment(payload)
    .subscribe((res: any) => {

      if (this.isEditing && this.editingIndex !== null) {
        this.comments[this.editingIndex] = res;
      } else {
        this.comments.unshift(res);
      }
    // notifier le parent
      this.commentsChange.emit({
        idPDT: this.idPDT,
        type: this.type,
        comments: [...this.comments]
      });
      this.resetForm();
    });
}

editComment(index: number) {
  const c = this.comments[index];

  this.newComment.commentaire = c.commentaire;

  this.editingIndex = index;
  this.isEditing = true;
}

resetForm() {
  this.newComment.commentaire = '';
  this.isEditing = false;
  this.editingIndex = null;
}

  closeModal() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.commentsChange.emit(this.comments);
    this.close.emit();
  }


  constructor(
    private treatmentMetaService: TreatmentPlanMetaService,
  ) { }

  ngOnInit() {
    this.currentUserValue();
  }


      public currentUserValue() {
        var value = localStorage.getItem('currentUser');
        var currentUser = JSON.parse(value);
        // console.log(this.currentUser);
        var name = "Dr " + currentUser.firstname + ' ' + currentUser.lastname;
        this.currentUser = name;
    }
}
